<app-pageheader Title="Sensors">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="true" ApiUrl="infrastructure/IRsensors/searches"
  [AllowEdit]="true" EditUrl="/parking/guidance/sensors/:id/edit" [StructureViewerLayers]="StructureViewerLayers" StructureViewerForType="IRSensor">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>